import { CSSProperties } from 'react';
import dayjs from 'dayjs';
import CryptoJS from 'crypto-js';
import { v4 as uuidv4 } from 'uuid';
import moment from './moment-tz';
import habit_one from '../assets/webp-images/habit_one.webp';
import habit_two from '../assets/webp-images/habit_two.png';
import habit_three from '../assets/webp-images/habit_three.webp';
import habit_four from '../assets/webp-images/habit_four.webp';

import instruction_one from '../assets/webp-images/instruction_one.webp';
import instruction_two from '../assets/webp-images/instruction_two.webp';
import instruction_three from '../assets/webp-images/instruction_three.webp';

import instructor_one from '../assets/webp-images/Gunjan.webp';
import instructor_two from '../assets/webp-images/Mala.webp';
import instructor_three from '../assets/webp-images/Sukhmani.webp';

import userProfileIcon1 from '../assets/new-icons/user-profile-icon-1.png';
import userProfileIcon2 from '../assets/new-icons/user-profile-icon-2.png';
import userProfileIcon3 from '../assets/new-icons/user-profile-icon-3.png';
import userProfileIcon4 from '../assets/new-icons/user-profile-icon-4.png';
import userProfileIcon5 from '../assets/new-icons/user-profile-icon-5.png';

export function isValidEmail(email: string): boolean {
	// Regular expression for a basic email format validation
	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

	return emailRegex.test(email);
}

export const slots = [
	{ value: '', label: 'Select' },
	{ value: 'Morning - 5:30 AM', label: 'Morning - 5:30 AM' },
	{ value: 'Morning - 6:30 AM', label: 'Morning - 6:30 AM' },
	{ value: 'Morning - 7:30 AM', label: 'Morning - 7:30 AM' },
	{ value: 'Evening - 9:30 PM', label: 'Evening - 9:30 PM' },
];

export const reason_for_joining = [
	{ value: '', label: 'Select' },
	{
		value: 'Help deal with overall health',
		label: 'Help deal with overall health',
	},
	{
		value: 'Managing high BP/hypertension',
		label: 'Managing high BP/hypertension',
	},
	{ value: 'Managing diabetes', label: 'Managing diabetes' },
	{
		value: 'To be more peaceful at work',
		label: 'To be more peaceful at work',
	},
	{ value: 'To be able to sleep better', label: 'To be able to sleep better' },
	{ value: 'Other', label: 'Other' },
];

export const genders = [
	{ value: 'male', label: 'Male' },
	{ value: 'female', label: 'Female' },
	{ value: 'others', label: 'Others' },
];

export const override: CSSProperties = {
	display: 'flex',
	position: 'absolute',
	left: '35%',
	top: '40%',
	zIndex: 10,
	borderColor: 'red',
};

export const Faqs1 = [
	{
		q: 'Where will I get more details and communication once I pay and sign-up?',
		a: 'You will be asked to join a WhatsApp group once you pay successfully and sign-up. All the important communications will be done on the WhatsApp group',
	},
	{
		q: 'Where will I get the link to join the class?',
		a: 'All the live classes will happen on Youtube and the link will be available on your web application after you are successfully logged-in.',
	},
	{
		q: 'Are all the classes same or different in a day?',
		a: 'Currently, all the classes are same within a day level but are different across the days. So you can join any one based on your convenience.',
	},
	{
		q: 'Can I get recordings of the class?',
		a: 'No, we strongly believe in habit building and hence want all Seekers to join live as it brings more accountability.',
	},
];

export const Faqs = [
	{
		q: 'When do the daily guided classes happen and can I attend multiple classes in a day?',
		a: 'The daily guided classes are available throughout the day. You can attend at any time and attend multiple classes in a day as well.',
	},
	{
		q: 'Are classes available in both English and Hindi?',
		a: 'Yes, some of our classes are in English and others in Hindi. You can choose the class that suits you the best.',
	},
	{
		q: 'When does the challenge start?',
		a: 'It is made for beginners which  starts every Monday. You can join an upcoming batch and begin your journey fresh each week—perfect for building consistency and easing into meditation.',
	},
	{
		q: 'Can I do it anytime of the day?',
		a: 'Yes, you can do it anytime that works for you! Each day, a new module is released and stays unlocked for the full 21 days.',
	},
	{
		q: 'Can I do the challenge multiple times?',
		a: 'Yes! You can join a new batch every Monday, but ensure to have active Seek subscription.',
	},
	{
		q: 'What do Seek’s courses include?',
		a: 'We offer multiple short and long-term courses on sleep improvement, reset, anxiety release, anger control, Kundalini, and more—designed for lasting well-being. ',
		b: 'New courses run every month, allowing you to continuously deepen your mindfulness journey and integrate meditation into your life.',
	},
	{
		q: 'Why choose longer plans over shorter ones?',
		a: 'Longer plans give you more time to build lasting habits and see deeper results.  With more time to practice, you’ll experience greater improvements in both mental and physical well-being.',
	},
	{
		q: 'How long will it take to see results?',
		a: 'Building a consistent meditation and yoga practice is a journey, not a quick fix. Most users begin to notice significant improvements within 3 to 6 weeks, as this is the time it takes to form lasting habits and cultivate a strong mindset.',
		b: 'While it’s easy to lose motivation midway, Seek helps you stay resilient and focused, strengthening your mindset to handle life’s challenges with confidence.',
	},
	{
		q: 'Are trial classes available?',
		a: 'We don’t offer trial classes because meaningful, lasting results require genuine commitment. With over 6,000 people already transforming their lives through our programs, we’ve seen firsthand that consistency is the key to success.',
		b: 'While anything less than 3 months might not create a significant impact on your physical and mental well-being, we’re dedicated to supporting you every step of the way.',
	},
	{
		q: 'Why we have subscription model?',
		a: 'It is a journey that requires consistency and continuous support.',
		b: 'With a subscription, you get unlimited access to our classes, resources, and personalized guidance that evolve with your needs, helping you stay on track and make meditation a natural part of your life.',
		c: 'It keeps you accountable and motivated, helping you stay committed even when life gets busy. With this structure, you’re more likely to see lasting results and build a sustainable meditation habit.',
	},
	{
		q: 'How to cancel subscription?',
		a: 'To cancel a subscription, open your UPI app (Google Pay, PhonePe, Paytm etc.), go to the Autopay or Mandates section, find the subscription, and select Cancel or Pause to stop future payments.',
		b: 'If paid via a debit/credit card, check your bank app under manage subscriptions and disable auto-renewal. You can also write on contact@seekapp.co if you face any issue in canceling your subscription.',
		c: 'IOS users can go to the App Store, select Subscriptions, and manage or cancel any active plans.',
	},
	{
		q: 'Where will I receive communication after signing up?',
		a: "You'll receive updates via the WhatsApp community. Whether you sign up through the website or the app, you’ll have access to all the classes on both platforms.",
	},
	{
		q: 'What if I have doubts regarding practice or program?',
		a: 'Practice related questions will be addressed during the live sessions with the instructor, which happen twice a week.',
		b: 'For any technical queries or support, please contact our customer support team at +91-9220578433 — we’re here to help!',
	},
	{
		q: 'What do short meditations include?',
		a: 'It generates short 5-10 min guided meditations tailored to your needs, available anytime in English or Hindi, customized to the problem you stated.',
	},
];

export const FaqsCourse = [
	{
		q: "What's the refund policy?",
		a: "If you don't enjoy the program, you can write to us on contact@seekapp.co within the 7 days of the program. Our team will refund you the full amount within the next 7 working days.",
	},
	{
		q: 'Where will I get more details and communication once I pay and register?',
		a: 'You will be asked to join a WhatsApp group once you have successfully paid and registered for the course. All important communications will be done through the WhatsApp group.',
	},
	{
		q: 'What happens if I miss a live session?',
		a: 'We highly encourage you to attend the live session along with your peers, so that you are on track with the daily practices and quiz. However, in special circumstances you can write to us and a recording will be provided for limited time.',
	},
	{
		q: 'What is the expected time commitment?',
		a: 'To get the maximum out of this course, please be prepared to spend 1 hour everyday on an average.',
	},
];

export const LandingFaqs = [
	{
		q: 'How can I join the classes once I sign-up?',
		a: 'You can join the classes from the website after you sign-up. The website will redirect you to Youtube App where the class is happening. You must have Youtube App on your device.',
	},
	{
		q: 'Can I attend the class in any of the given time slots?',
		a: 'Yes, you can attend the class at any of the given time slots convenient to you. In fact, a lot of our users even attend the class multiple times in a day.',
	},
	{
		q: 'What if I need to ask questions from the instructor? ',
		a: 'You can either fill the QnA form which is available in every class or reach out to the support team or attend our community session every other Sunday.',
	},
	{
		q: 'Will the classes happen on Holidays too?',
		a: 'Yes. 365 days a year. 70% of our users attended classes even during the new year. ',
	},
	{
		q: 'What are the styles of meditation will be covered in the program?',
		a: 'We have expert to guide you with different modalities including Kundalini, Chakra, Vipassana, Access Conciousness and many more.',
	},
];

interface AttendanceData {
	weekStartDate: string; // Update the type based on your data
	weekEndDate: string; // Update the type based on your data
	weekly_attendance: string[]; // Update the type based on your data
}

interface DayAttendance {
	day: string;
	icon: string;
	parsedCurrentDate: string;
}

export const parsedAttendanceData = (
	attendance: AttendanceData,
	parsedStartDate: string,
	parsedEndDate: string
): DayAttendance[] => {
	// if(Object.keys(attendance).length === 0){
	//     return []
	// }

	const weekStartDate = new Date(attendance?.weekStartDate || parsedStartDate);
	const weekEndDate = new Date(attendance?.weekEndDate || parsedEndDate);

	const daysInWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

	const parsedData: DayAttendance[] = daysInWeek.map((day) => {
		const currentDate = new Date(weekStartDate);
		currentDate.setDate(currentDate.getDate() + daysInWeek.indexOf(day));

		const parsedCurrentDate = currentDate.toISOString().split('T')[0];
		// console.log("parsedCurrentDate",parsedCurrentDate);
		// console.log("attendance.weekly_attendance",typeof attendance.weekly_attendance);

		const isPresent =
			attendance.weekly_attendance &&
			typeof attendance.weekly_attendance === 'object' &&
			attendance.weekly_attendance.hasOwnProperty(parsedCurrentDate);
		return {
			day,
			icon: isPresent ? 'Present' : 'Absent',
			parsedCurrentDate: parsedCurrentDate,
		};
	});
	return parsedData;
};

export const isWithingStreamingTimeWindow = (): boolean => {
	const localTime = moment();

	// Convert the local time to IST
	const istTime = localTime.tz('Asia/Kolkata').format('YYYY-MM-DD HH:mm:ss'); // 'Asia/Kolkata' is the timezone for IST

	// Check if the current IST time is in the morning (5am to 8:30am)
	const isMorning = moment
		.tz(istTime, 'Asia/Kolkata')
		.isBetween(
			moment.tz('05:00', 'Asia/Kolkata'),
			moment.tz('08:30', 'Asia/Kolkata'),
			undefined,
			'[)'
		);

	// Check if the current IST time is in the evening (7pm to 10pm)
	const isEvening = moment
		.tz(istTime, 'Asia/Kolkata')
		.isBetween(
			moment.tz('19:00', 'Asia/Kolkata'),
			moment.tz('22:00', 'Asia/Kolkata'),
			undefined,
			'[)'
		);

	return isMorning || isEvening;
};

export const TermsAndCondition = {
	title: 'Terms & Conditions',
	subtitle: null,
	body: "Use of this site is provided by Seek Meditation (henceforth referred to as Seek) subject to the following of the Terms and conditions as given below.​Your use and access to the website constitute acceptance of these Terms and Conditions as at the date of your first use of the website.You agree to use the website only for lawful purposes, and in a manner which does not infringe the rights, or restrict, or inhibit the use and enjoyment of the website by any third party.Seek reserves the rights to change these Terms and Conditions at any time by posting changes online. Your continued use of the website after changes are posted constitutes your acceptance of the new Terms and Conditions as modified automatically. You should, therefore, review these Terms and Conditions regularly.Seek takes no responsibility for the content of external internet websites. Following links to any other websites or pages shall be at your own risk and Seek shall not be responsible or liable, directly or indirectly, for any damages resulting from the use of such other websites.All intellectual property on the website and the material or information it contains including without limitation copyright, designs, database rights and trademarks (registered or unregistered) are and shall remain the property of Seek or its third party licensors.Commercial use or publication of all or any item displayed on the site without authorization from Seek is strictly prohibited. Nothing contained in these Terms and Conditions shall be construed as conferring any licensee by Seek to use any item displayed.Materials in the website may be copied for personal use only on the condition that all copyright notices and source indications are also reproduced, no modifications are made and each relevant item is copied in its entirety. Some materials that have been outsourced have been published on the website with all the necessary permissions from the relevant copyright owners (who are not part of Seek). All rights are reserved on these materials and permission to copy them must be requested. from the individual copyright owners (as indicated within these materials).Any communication or material that you transmit to, or post on, any public area of the website including any data, questions, comments, suggestions, or the like, is and will be treated as non-confidential and non-proprietary information. Seek reserves the right to remove any such communication or material from the website at its own discretion.If there is any conflict between these Terms and Conditions and rules and/or specific terms of use appearing on the Website relating to specific material then the latter shall prevail.If these Terms and Conditions are not accepted in full, the use of the website must be terminated immediately.Visitors acknowledge that visiting this site is an implicit acceptance of these 'Terms and Conditions' on their part.Accepting 'Terms and Conditions' means an implicit acceptance of our Disclaimer and Privacy PolicyRefund Policy: In case the participant fails to join the live session of the program he/she signed up for, Seek will give the option to join any of the upcoming programs or issue a complete refund to the individual within 7 days from the date program ends.In case the individual has attended any of the live sessions (program or community), Seek is not liable to issue any refund.For any further queries or questions, please feel free to write us at info@Seek.org",
	phone: null,
	email: null,
};

export const ContactUs = {
	title: 'Contact Us',
	subtitle: "We're here to support you on your meditation journey.",
	body: "Reach out with any questions via email or phone mentioned below, and we'll ensure your issue is resolved within 24 hours for a smooth experience.",
	phone: '+91-9220578433',
	email: 'contact@seekapp.co',
};

export const PrivacyPolicy = {
	title: 'Privacy Policy',
	subtitle: 'Effective date: 2023-09-25.',
	body: 'Introduction: Welcome to Seek. Seek (“us”, “we”, or “our”) operates seekapp.co (hereinafter referred to as “Service”). Our Privacy Policy governs your visit to seekapp.co, and explains how we collect, safeguard and disclose information that results from your use of our Service. We use your data to provide and improve Service. By using Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, the terms used in this Privacy Policy have the same meanings as in our Terms and Conditions. Our Terms and Conditions (“Terms”) govern all use of our Service and together with the Privacy Policy constitutes your agreement with us (“agreement”).Definitions SERVICE means the seekapp.co website operated by Seek. PERSONAL DATA means data about a living individual who can be identified from those data (or from those and other information either in our possession or likely to come into our possession).USAGE DATA is data collected automatically either generated by the use of Service or from Service infrastructure itself (for example, the duration of a page visit). COOKIES are small files stored on your device (computer or mobile device). DATA CONTROLLER means a natural or legal person who (either alone or jointly or in common with other persons) determines the purposes for which and the manner in which any personal data are, or are to be, processed. For the purpose of this Privacy Policy, we are a Data Controller of your data. DATA PROCESSORS (OR SERVICE PROVIDERS) means any natural or legal person who processes the data on behalf of the Data Controller. We may use the services of various Service Providers in order to process your data more effectively. DATA SUBJECT is any living individual who is the subject of Personal Data.THE USER is the individual using our Service. The User corresponds to the Data Subject, who is the subject of Personal Data.Information Collection and UseWe collect several different types of information for various purposes to provide and improve our Service to you. Types of Data CollectedPersonal DataWhile using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you (“Personal Data”). Personally identifiable information may include, but is not limited to: 0.1. Email address 0.2. First name and last name 0.3. Phone number 0.4. Address, Country, State, Province, ZIP/Postal code, City.Cookies and Usage DataWe may use your Personal Data to contact you with newsletters, marketing or promotional materials and other information that may be of interest to you. You may opt out of receiving any, or all, of these communications from us by following the unsubscribe link.Usage DataWe may also collect information that your browser sends whenever you visit our Service or when you access Service by or through any device (“Usage Data”).This Usage Data may include information such as your computer’s Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.When you access Service with a device, this Usage Data may include information such as the type of device you use, your device unique ID, the IP address of your device, your device operating system, the type of Internet browser you use, unique device identifiers and other diagnostic data.Tracking Cookies DataWe use cookies and similar tracking technologies to track the activity on our Service and we hold certain information.Cookies are files with a small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device. Other tracking technologies are also used such as beacons, tags and scripts to collect and track information and to improve and analyze our Service.You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.Examples of Cookies we use:0.1. Session Cookies: We use Session Cookies to operate our Service.0.2. Preference Cookies: We use Preference Cookies to remember your preferences and various settings.0.3. Security Cookies: We use Security Cookies for security purposes.0.4. Advertising Cookies: Advertising Cookies are used to serve you with advertisements that may be relevant to you and your interests.Other DataWhile using our Service, we may also collect the following information: sex, age, date of birth, place of birth, passport details, citizenship, registration at place of residence and actual address, telephone number (work, mobile), details of documents on education, qualification, professional training, employment agreements, NDA agreements, information on bonuses and compensation, information on marital status, family members, social security (or other taxpayer identification) number, office location and other data.5. Use of DataSeek uses the collected data for various purposes:0.1. to provide and maintain our Service;0.2. to notify you about changes to our Service;0.3. to allow you to participate in interactive features of our Service when you choose to do so;0.4. to provide customer support;0.5. to gather analysis or valuable information so that we can improve our Service;0.6. to monitor the usage of our Service;0.7. to detect, prevent and address technical issues;0.8. to fulfil any other purpose for which you provide it;0.9. to carry out our obligations and enforce our rights arising from any contracts entered into between you and us, including for billing and collection;0.10. to provide you with notices about your account and/or subscription, including expiration and renewal notices, email-instructions, etc.;0.11. to provide you with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless you have opted not to receive such information;0.12. in any other way we may describe when you provide the information;0.13. for any other purpose with your consent.6. Retention of DataWe will retain your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.We will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period, except when this data is used to strengthen the security or to improve the functionality of our Service, or we are legally obligated to retain this data for longer time periods.7. Transfer of DataYour information, including Personal Data, may be transferred to – and maintained on – computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ from those of your jurisdiction.If you are located outside India and choose to provide information to us, please note that we transfer the data, including Personal Data, to India and process it there.Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.Seek will take all the steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organisation or a country unless there are adequate controls in place including the security of your data and other personal information.8. Disclosure of DataWe may disclose personal information that we collect, or you provide:0.1. Disclosure for Law Enforcement.Under certain circumstances, we may be required to disclose your Personal Data if required to do so by law or in response to valid requests by public authorities.0.2. Business Transaction.If we or our subsidiaries are involved in a merger, acquisition or asset sale, your Personal Data may be transferred.0.3. Other cases. We may disclose your information also:0.3.1. to our subsidiaries and affiliates;0.3.2. to contractors, service providers, and other third parties we use to support our business;0.3.3. to fulfill the purpose for which you provide it;0.3.4. for the purpose of including your company’s logo on our website;0.3.5. for any other purpose disclosed by us when you provide the information;0.3.6. with your consent in any other cases;0.3.7. if we believe disclosure is necessary or appropriate to protect the rights, property, or safety of the Company, our customers, or others.9. Security of DataThe security of your data is important to us but remember that no method of transmission over the Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.10. Your Data Protection Rights Under General Data Protection Regulation (GDPR)If you are a resident of the European Union (EU) and European Economic Area (EEA), you have certain data protection rights, covered by GDPR.We aim to take reasonable steps to allow you to correct, amend, delete, or limit the use of your Personal Data.If you wish to be informed what Personal Data we hold about you and if you want it to be removed from our systems, please email us at info@seekapp.co.In certain circumstances, you have the following data protection rights:0.1. the right to access, update or to delete the information we have on you;0.2. the right of rectification. You have the right to have your information rectified if that information is inaccurate or incomplete;0.3. the right to object. You have the right to object to our processing of your Personal Data;0.4. the right of restriction. You have the right to request that we restrict the processing of your personal information;0.5. the right to data portability. You have the right to be provided with a copy of your Personal Data in a structured, machine-readable and commonly used format;0.6. the right to withdraw consent. You also have the right to withdraw your consent at any time where we rely on your consent to process your personal information;Please note that we may ask you to verify your identity before responding to such requests. Please note, we may not able to provide Service without some necessary data.You have the right to complain to a Data Protection Authority about our collection and use of your Personal Data. For more information, please contact your local data protection authority in the European Economic Area (EEA).11. Your Data Protection Rights under the California Privacy Protection Act (CalOPPA)CalOPPA is the first state law in the nation to require commercial websites and online services to post a privacy policy. The law’s reach stretches well beyond California to require a person or company in the United States (and conceivable the world) that operates websites collecting personally identifiable information from California consumers to post a conspicuous privacy policy on its website stating exactly the information being collected and those individuals with whom it is being shared, and to comply with this policy.According to CalOPPA we agree to the following:0.1. users can visit our site anonymously;0.2. our Privacy Policy link includes the word “Privacy”, and can easily be found on the home page of our website;0.3. users will be notified of any privacy policy changes on our Privacy Policy Page;0.4. users are able to change their personal information by emailing us at info@seekapp.co.Our Policy on “Do Not Track” Signals:We honor Do Not Track signals and do not track, plant cookies, or use advertising when a Do Not Track browser mechanism is in place. Do Not Track is a preference you can set in your web browser to inform websites that you do not want to be tracked.You can enable or disable Do Not Track by visiting the Preferences or Settings page of your web browser.12. Your Data Protection Rights under the California Consumer Privacy Act (CCPA)If you are a California resident, you are entitled to learn what data we collect about you, ask to delete your data and not to sell (share) it. To exercise your data protection rights, you can make certain requests and ask us:0.1. What personal information we have about you. If you make this request, we will return to you:0.0.1. The categories of personal information we have collected about you.0.0.2. The categories of sources from which we collect your personal information.0.0.3. The business or commercial purpose for collecting or selling your personal information.0.0.4. The categories of third parties with whom we share personal information.0.0.5. The specific pieces of personal information we have collected about you.0.0.6. A list of categories of personal information that we have sold, along with the category of any other company we sold it to. If we have not sold your personal information, we will inform you of that fact.0.0.7. A list of categories of personal information that we have disclosed for a business purpose, along with the category of any other company we shared it with.Please note, you are entitled to ask us to provide you with this information up to two times in a rolling twelve-month period. When you make this request, the information provided may be limited to the personal information we collected about you in the previous 12 months.0.2. To delete your personal information. If you make this request, we will delete the personal information we hold about you as of the date of your request from our records and direct any service providers to do the same. In some cases, deletion may be accomplished through de-identification of the information. If you choose to delete your personal information, you may not be able to use certain functions that require your personal information to operate.0.3. To stop selling your personal information. We don’t sell or rent your personal information to any third parties for any purpose. We do not sell your personal information for monetary consideration. However, under some circumstances, a transfer of personal information to a third party, or within our family of companies, without monetary consideration may be considered a “sale” under California law. You are the only owner of your Personal Data and can request disclosure or deletion at any time.If you submit a request to stop selling your personal information, we will stop making such transfers.Please note, if you ask us to delete or stop selling your data, it may impact your experience with us, and you may not be able to participate in certain programs or membership services which require the usage of your personal information to function. But in no circumstances, we will discriminate against you for exercising your rights.To exercise your California data protection rights described above, please send your request(s) by email: info@seekapp.co.Your data protection rights, described above, are covered by the CCPA, short for the California Consumer Privacy Act. To find out more, visit the official California Legislative Information website. The CCPA took effect on 01/01/2020.13. Service ProvidersWe may employ third party companies and individuals to facilitate our Service (“Service Providers”), provide Service on our behalf, perform Service-related services or assist us in analysing how our Service is used.These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.14. AnalyticsWe may use third-party Service Providers to monitor and analyze the use of our Service.15. CI/CD toolsWe may use third-party Service Providers to automate the development process of our Service.16. Behavioral RemarketingWe may use remarketing services to advertise on third party websites to you after you visited our Service. We and our third-party vendors use cookies to inform, optimise and serve ads based on your past visits to our Service.17. PaymentsWe may provide paid products and/or services within Service. In that case, we use third-party services for payment processing (e.g. payment processors).We will not store or collect your payment card details. That information is provided directly to our third-party payment processors whose use of your personal information is governed by their Privacy Policy. These payment processors adhere to the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa, Mastercard, American Express and Discover. PCI-DSS requirements help ensure the secure handling of payment information.18. Links to Other SitesOur Service may contain links to other sites that are not operated by us. If you click a third party link, you will be directed to that third party’s site. We strongly advise you to review the Privacy Policy of every site you visit.We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.19. Children’s Privacy Our Services are not intended for use by children under the age of 18 (“Child” or “Children”).We do not knowingly collect personally identifiable information from Children under 18. If you become aware that a Child has provided us with Personal Data, please contact us. If we become aware that we have collected Personal Data from Children without verification of parental consent, we take steps to remove that information from our servers.20. Changes to This Privacy PolicyWe may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.We will let you know via email and/or a prominent notice on our Service, prior to the change becoming effective and update “effective date” at the top of this Privacy Policy.You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.21. Contact UsIf you have any questions about this Privacy Policy, please contact us by email: info@seekapp.co.',
	phone: null,
	email: null,
};

export const CancellationPolicy = {
	title: 'Cancellation Policy',
	subtitle: null,
	body:
		"Saadhna reserves the right to cancel, reschedule or delay the commencement or continuance of a scheduled session or to alter the meeting link or to change the session topic or to change the instructor without incurring any liability in damages or otherwise to the Customers or any other person whatsoever. Sometimes circumstances beyond Saadhna's control result in delays or cancellations. In such circumstances, Saadhna reserves the right to cancel or delay a session without prior notice. Circumstances beyond Saadhna's control can include, without limitation, internet issues, hosting failures, website failures, governmental regulations, orders, demands or requirements, shortages of critical manpower, etc. In case of delays  or cancellations, customers are not entitled for a refund of the donation amount. We will get within 7-10 working days to reschedule the live session. \n" +
		'\n' +
		' \n' +
		'\n' +
		'We block time with our instructors our instructors for all live classes. We urge you to not cancel scheduled 1-on-1 live classes. If you have to please do so 48 hours in advance.',
	phone: null,
	email: null,
};

type Progress = {
	'0': number;
	'1': number;
	'2': number;
	'3': number;
	'4': number;
	'5': number;
	'6': number;
};
type IndexedProgress = Progress & { [key: string]: number };

export const Marker = [
	{ position: 4, label: '0' },
	{ position: 19.33, label: '1' },
	{
		position: 34.66,
		label: '2',
	},
	{ position: 49.99, label: '3' },
	{ position: 65.32, label: '4' },
	{ position: 80.65, label: '5' },
	{
		position: 96,
		label: '6+',
	},
];
export const Progress: IndexedProgress = {
	'0': 4,
	'1': 19.33,
	'2': 34.66,
	'3': 49.99,
	'4': 65.32,
	'5': 80.65,
	'6': 96,
	'7': 100,
};

interface DateWithPoints {
	date: string;
	points: number;
}

export const createArrayOfDatesWithPoints = (
	startDate: Date,
	endDate: Date
): DateWithPoints[] => {
	const dateArray: DateWithPoints[] = [];

	function addDays(date: Date, days: number): Date {
		const result = new Date(date);
		result.setDate(result.getDate() + days);
		return result;
	}

	let currentDate = startDate;
	while (currentDate <= endDate) {
		// Format the date as 'YYYY-MM-DD'
		const formattedDate = currentDate.toISOString().split('T')[0];

		dateArray.unshift({ date: formattedDate, points: 0 });

		currentDate = addDays(currentDate, 1);
	}

	return dateArray;
};

export const createKarmaHistory = (
	start: string,
	parsedEndDate: string,
	data: any
): DateWithPoints[] => {
	if (!data) return [];
	const datePointsMap: Record<string, number> = {};
	data.forEach((item: any) => {
		datePointsMap[item.date] = item.points;
	});

	const startDate = new Date(start);
	const endDate = new Date(
		Math.max(...data.map((item: any) => new Date(item.date)))
	);

	const resultArray: DateWithPoints[] = [];
	for (
		let currentDate = startDate;
		currentDate <= endDate;
		currentDate.setDate(currentDate.getDate() + 1)
	) {
		const formattedDate = currentDate.toISOString().split('T')[0];
		const points = datePointsMap[formattedDate] || 0;
		resultArray.unshift({ date: formattedDate, points: points });
	}

	return resultArray;
};

interface User {
	name: string;
	phone: string;
	total_karma: string | number; // Assuming total_karma can be either string or number
	rank: number;
	userId: string;
}

// export function getUserListWithSpecialUser(
// 	users: User[],
// 	targetPhone: string
// ): User[] {
// 	if (!users || users?.length == 0) return [];
//
// 	const result: User[] = [];
//
// 	let specialUserFound = false;
//
// 	for (let i = 0; i < Math.min(3, users.length); i++) {
// 		result.push(users[i]);
//
// 		// Check if specialUser is present in the first three users
// 		if (users[i].phone === targetPhone) {
// 			specialUserFound = true;
// 		}
// 	}
//
// 	// If specialUser is not found in the first three users, find and push it
// 	if (!specialUserFound) {
// 		const specialUser = users.find((user) => user.phone === targetPhone);
// 		if (specialUser) {
// 			result.push(specialUser);
// 		}
// 	}
//
// 	return result;
// }

export function getUserListWithSpecialUser(
	users: User[],
	currentUser: User
): User[] {
	if (!currentUser) return users.slice(0, 4);
	if (!users || users?.length === 0) return [];

	const result: User[] = [];

	let specialUserFound = false;

	for (let i = 0; i < Math.min(3, users.length); i++) {
		result.push(users[i]);

		// Check if specialUser is present in the first three users
		if (users[i]?.userId === currentUser?.userId) {
			specialUserFound = true;
		}
	}

	// If specialUser is not found in the first three users, find and push it
	if (!specialUserFound) {
		result.push(currentUser);
	}

	return result;
}

export function getTodayDateInUtc(): string {
	const formattedDate = new Date().toLocaleDateString('en-GB');
	const [day, month, year] = formattedDate.split('/');
	const parsedToday = `${year}-${month}-${day}`;
	return parsedToday;
}

export const getLastAttendance = (lastAttendance: any): string => {
	if (!lastAttendance) return '';
	const dates = Object.keys(lastAttendance);
	if (dates.length > 0) {
		const maxDate = dates.reduce(
			(max, date) => (date > max ? date : max),
			dates[0]
		);
		return dayjs(maxDate).format('DD MMM YY');
	} else {
		return '';
	}
};

// export const Testers = ['jain3754@gmail.com', 'amanj120294@gmail.com', 'kshitij@seekapp.co', 'sameershekhar90@gmail.com', 'sameer@seekapp.co', 'parul291299@gmail.com']
export const Testers = [
	'919959637700',
	'919535472514',
	'919667652115',
	'919509240643',
	'919555434844',
	'919999999998',
	'919717071509',
	'919220578433',
	'918130813037',
];
export const FREE_UPGRADE_PLAN_POPUP_BUFFER_DAYS = 4;
export const PAID_UPGRADE_PLAN_POPUP_BUFFER_DAYS = 7;
export const FREE_TRAIL_ENDS_BUFFER_DAYS = 6;
export const STREAMING_PLAN_RECURRENCE_TYPE = {
	MONTHLY: 'monthly',
	QUARTERLY: 'quarterly',
	HALF_YEARLY: 'half_yearly',
	YEARLY: 'yearly',
	FREE: 'FREE',
	REFERRAL: 'REFERRAL',
};

export const LANDING_COMPONENT = {
	HABIT: 'HABIT',
	INSTRUCTOR: 'INSTRUCTOR',
	INSTRUCTIONS: 'INSTRUCTIONS',
	TESTIMONIAL: 'TESTIMONIAL',
	MINDFULNESS: 'MINDFULNESS',
};

export const HabitsCarouselItems = [
	{
		imageUrl: habit_one,
		title: '30 minutes sessions',
		subtitle:
			'Engage in dynamic session power packed with body movements, breathwork and meditation',
	},
	{
		imageUrl: habit_two,
		title: '10 time slots everyday',
		subtitle:
			'10 time slots in morning & evening offer the flexibility you need. Attend as many as you want',
	},
	{
		imageUrl: habit_three,
		title: 'Wide variety of classes',
		subtitle:
			'A different type of class for every mood, helping you be more regular than anywhere else',
	},
	{
		imageUrl: habit_four,
		title: 'Classes in both English and Hindi',
		subtitle: "Because Language shouldn't be a barrier to your mindfulness",
	},
];

export const MindfulnessCarouselItems = [
	{
		imageUrl: 'Images/mind_one.svg',
		title: 'Reduced Stress',
		subtitle:
			'80% of Seekers reported reduced stress in their daily life within 5 days of regular practice',
	},
	{
		imageUrl: 'Images/mind_two.svg',
		title: 'Better Immunity',
		subtitle:
			'Specialised practices/affirmations like better lung capacity, gut health and stronger nervous system focus on  increasing overall immunity',
	},
	{
		imageUrl: 'Images/mind_three.svg',
		title: 'Better Sleep',
		subtitle:
			'5 out of 6 Seekers who attend our evening classes experience better sleep',
	},
];

export const InstructorCarouselItems = [
	{
		imageUrl: 'Images/gunjan.webp',
		title: 'Gunjan Amrit',
		subtitle: '- Kundalini Expert',
		conversations: '310+ conversations',
		description:
			'Learned under the guidance of Gurumukh Kaur Khalsa, the technology of Kundalini Yoga has been foundational practice for Gunjan over 15 years, which she shares to empower people all over the globe. She has 20+ Years of experience as a certified ayurveda therapist along with a practitioner in various alternate medicine forms which includes bach flower remedies and somatic therapy.',
	},
	{
		imageUrl: 'Images/mala.webp',
		title: 'Mala Barua',
		subtitle: '- Inner Silence Meditation Expert',
		conversations: '330+ Conversations',
		description:
			'Mala Barua has been teaching Inner Silence Meditation (Antar Mauna) for the last 20 years. She is also a qualified Yoga and Tai Chi teacher and an eternal student of Vedanta. She is the author of 2 Vegan cookbooks and 1 on the Divine Feminine. Her journey is guided by her Guru Swami Anubhavanandaji, a Master of Vedanta.',
	},
	{
		imageUrl: 'Images/apporva.webp',
		title: 'Apoorva Behal',
		subtitle: '- Samatha Vipassana Expert',
		conversations: '270+ Conversations',
		description:
			'Apoorva, brings in the perfect alchemy of Yin yoga and Vipassana Meditation, teaches this powerful technique especially for beginners. Apoorva brings in >7 years of experience as a meditation coach and loves to travel the world to learn newer modalities from all countries. She completed her Yin Yoga training with one of the most renowned teachers in the US.',
	},
	{
		imageUrl: 'Images/neha.webp',
		title: 'Neha Prabhakar',
		subtitle: '- Hypnotherapy Expert',
		conversations: '250+ Conversations',
		description:
			'Neha is a Psychologist, Hypnotherapist and a Meditation Coach. As a dedicated meditation practitioner with expertise in yoga, she has a rich background in mind-body practices. Neha teaches her clients a variety of meditation techniques to stay focused, relaxed, and positive in life.',
	},
];

export const CalendarCarouselItems = [
	{
		imageUrl: 'Images/instructor-gunjan.webp',
		title: 'Meditate to the Sounds of Nature 1.',
		date: '19 Jan 24',
		duration: '25:00 Mins',
	},
	{
		imageUrl: 'Images/instructor-gunjan.webp',
		title: 'Meditate to the Sounds of Nature 2.',
		date: '19 Jan 24',
		duration: '25:00 Mins',
	},
];

export const TestimonialCarouselItems = [
	{
		date: '23 Sep 24',
		imageUrl: 'Images/Priya_Rajaram.webp',
		title: 'Ms Priya Rajaram',
		subtitle: 'Singapore',
		description:
			'Because of Seek, I am able to meditate daily. Usually, something else takes priority in daily life but doing it with a group of people with flexible timings is very powerful. Although childish, I love the leaderboard and want to be at the top of it every week',
	},
	{
		imageUrl: 'Images/Niraj_Bahekar.webp',
		title: 'Mr Niraj Bahekar',
		subtitle: 'India',
		description:
			'The quality of teachers is amazing. I will give 5/5 to the teachers. I get to learn something new every week which makes me go deeper into those myself',
	},
	{
		imageUrl: 'Images/Ajit_Chaturvedi.webp',
		title: 'Mr Ajit Chaturvedi',
		subtitle: 'India',
		description:
			'The constant nudge and community support is very good. Even if I miss meditating for a couple of days, the nudge and support makes me get back to it. I have restarted my daily practice and really enjoying the daily classes now',
	},
];

export const TestimonialCounsellingItems = [
	{
		date: '23 June 24',
		title: 'Neelam Goswami',
		subtitle: 'Singapore',
		description:
			'I had anger issues that were affecting my relationships, and the expert I spoke with recommended a combination of yoga and meditation techniques. The personalized advice I received has made a significant difference in my life. This service is a game-changer!',
	},
	{
		date: '21 March 24',
		title: 'Priya Singh',
		subtitle: 'India',
		description:
			'I struggled with gut health problems for years, and traditional treatments didn’t help much. The expert recommended a holistic approach combining reiki and mindfulness. Their advice was straightforward and practical. Within days, I felt a noticeable difference in my well-being.',
	},
	{
		date: '17 June 24',
		title: 'Arjun Agarwal',
		subtitle: 'India',
		description:
			"I've tried countless ways to manage my stress, but nothing worked until I found this service. I was skeptical at first, but after a 10-minute call, the expert recommended a specific meditation technique that changed everything for me. Their understanding and personalized advice were exactly what I needed.",
	},
	{
		date: '2 July 24',
		title: 'Pankaj Arora',
		subtitle: 'India',
		description:
			'Chronic pain had taken over my life, and I was desperate for relief. I called and spoke with an expert who recommended a personalized combination of Reiki and meditation. Their empathy and expertise were evident from the start. The pain has lessened, and I feel more hopeful than I have in years.',
	},
];

export const InstructionsCarouselItems = [
	{
		imageUrl: instruction_one,
		description:
			'All you need is WhatsApp, YouTube and you are set to start your meditation journey',
	},
	{
		imageUrl: instruction_two,
		description:
			'Track your daily attendance, feature on the leaderboard and get motivated everyday',
	},
	{
		imageUrl: instruction_three,
		description: 'Become part of a global thriving community of Seekers',
	},
];

export const OptionsOnLanding = [
	{ icon: 'LearnIcon', title: 'Learn new techniques of meditation' },
	{
		icon: 'GoDeeperIcon',
		title: 'Go deeper into your current meditation practice',
	},
	{
		icon: 'ConsistentIcon',
		title: 'Become more consistent with daily meditation',
		subtitle: '',
	},
	{ icon: 'SelfImprovementIcon', title: 'Self-Improvement' },
	{ icon: 'SleepIcon', title: 'Improve sleep quality and focus' },
	{ icon: 'StressIcon', title: 'Reduce Stress' },
];

export const SignupOptionStep = [
	{
		icon: 'SignUpStep1',
		title: 'Step 1',
		subtitle1: 'First, we will get to ',
		subtitle2: 'know you',
	},
	{
		icon: 'SignUpStep2',
		title: 'Step 2',
		subtitle1: 'Next, we will ',
		subtitle2: 'customise your program',
	},
	{
		icon: 'SignUpStep3',
		title: 'Step 3',
		subtitle1: 'Finally, we will ',
		subtitle2: 'set up your plan',
	},
];

export const OptionsOnExperience = [
	{ icon: 'Never', title: 'Never tried' },
	{ icon: 'Few', title: 'Tried a few times' },
	{ icon: 'Lot', title: 'I meditate regularly' },
];

export const OptionsOnLanguage = [
	{ icon: '', title: 'English' },
	{ icon: '', title: 'Hindi' },
	{ icon: '', title: 'Any of the above' },
];

export const OptionsOnPhysicalIntensity = [
	{ icon: 'Low', title: 'Easy' },
	{ icon: 'Medium', title: 'Medium' },
	{ icon: 'High', title: 'Hard' },
];

export const OptionsOfPriorities = [
	{ icon: 'Focus', title: 'Improve Focus' },
	{ icon: 'Sleep', title: 'Better Sleep' },
	{ icon: 'Stress', title: 'Reduce Stress' },
	{ icon: 'Anxiety', title: 'Overcome Anxiety' },
	{ icon: 'Something', title: 'Something else' },
];

export const OptionsOfAgeGroup = [
	{ value: '-20', title: 'Below 20' },
	{ value: '20-30', title: '20-30' },
	{ value: '30-40', title: '30-40' },
	{ value: '40-50', title: '40-50' },
	{ value: '50-60', title: '50-60' },
	{ value: '60+', title: '60+' },
];

export const OptionsOfSetGoals = [
	{ value: '1 Day in a week', title: '1 Day in a week' },
	{ value: '2 Days in a week', title: '2 Days in a week' },
	{ value: '3 Days in a week', title: '3 Days in a week' },
	{ value: '4 Days in a week', title: '4 Days in a week' },
	{ value: '5 Days in a week', title: '5 Days in a week' },
	{ value: '6 Days in a week', title: '6 Days in a week' },
	{ value: '7 Days in a week', title: '7 Days in a week' },
];

export const MorningTimeSlots = [
	{ slot: '5:30 AM' },
	{ slot: '6:30 AM' },
	{ slot: '7:30 AM' },
	{ slot: '8:30 AM' },
];

export const EveningTimeSlots = [
	{ slot: '7:30 PM' },
	{ slot: '8:30 PM' },
	{ slot: '9:30 PM' },
];

export const getYoutubeVideoId = (url: string): string | null => {
	const match = url.match(/[?&]v=([^?&]+)/);

	// The video ID is in the first capturing group
	return match ? match[1] : null;
};

export const sampleClassesData = [
	{
		title: 'Strengthening Nervous System',
		date: '12th April',
		author: 'Gunjan Amrit',
		url: 'https://www.youtube.com/watch?v=I_hHoxT7RCM',
	},
	{
		title: 'Reflecting on Year 2023',
		date: '31st December',
		author: 'By Apoorva Behal',
		url: 'https://www.youtube.com/watch?v=Bq-Af80aHJs',
	},
	{
		title: 'Decoding Likes and Dislikes',
		date: '31st March',
		author: 'By Mala Barua',
		url: 'https://www.youtube.com/watch?v=GAohzxwm6AA',
	},
];

export const Reviews = [
	{
		imageSrc: '',
		name: 'Niraj Bahekar',
		period: '3',
		bio: 'The quality of teachers is amazing. I would give a 5/5 rating to the teachers.',
		rating: 5,
	},
	{
		imageSrc: '',
		name: 'Priya Rajaram',
		period: '3',
		bio: 'Because of Seek, I am able to meditate daily. Usually, Something else takes priority in daily life but doing it with a group of people with fexible timings is very powerful.',
		rating: 5,
	},
	{
		imageSrc: '',
		name: 'Amit Chaturvedi ',
		period: '2',
		bio: "What I love most is the consistency it brings to my life. Amid life's chaos, Seek ground me, helping me focus on self-care and personal growth",
		rating: 5,
	},
	{
		imageSrc: '',
		name: 'Gopalakrishnan',
		period: '2',
		bio: 'Thank you, Seek, for the excellent sessions, as always, on stabilizing the mind, body, emotions, and life energies.',
		rating: 5,
	},
	{
		imageSrc: '',
		name: 'Praneet Khanna',
		period: '2',
		bio: 'The visualization technique was so unique and really enhanced my awareness and truly helped to create awareness.',
		rating: 4,
	},
	{
		imageSrc: '',
		name: 'Kamal Chandwaney',
		period: '1',
		bio: 'I truly enjoy the morning sessions and the simplicity of the instructions. I appreciate the power and energy I feel within myself.',
		rating: 4,
	},
];

export const CourseReviews = [
	{
		imageSrc: '',
		name: 'Mamta',
		bio: 'The amalgamation of chanting, breath work, asanas and Gunjan’s gentle motivating voice creates the ideal space for a transforming yoga experience .',
		rating: 5,
		period: '5',
	},
	{
		imageSrc: '',
		name: 'Nikita',
		bio: 'Practising Kundalini Yoga with  Gunjan made me embark on a very blessed and beautiful journey. Was able to shake off some of my limited beliefs with her practice . Her gentle guidance without intruding guides you to a new path of self discovery.',
		rating: 5,
		period: '4',
	},
	{
		imageSrc: '',
		name: 'Jeet',
		bio: 'Just like when we are on our Spiritual journey the Guru appears….similarly when I was ready for inner transformation and connection to my higher self i received this gift and path of Kundalini Yoga.In gratitude as I thank you for being that Guiding force forever and ever 💝',
		rating: 5,
		period: '3',
	},
	{
		imageSrc: '',
		name: 'Supriya',
		bio: 'I was introduced to Kundalini Yoga by Gunjan Amrit. I have been practising Hatha Yoga and Aerial Yoga but Kundalini Yoga opened a new dimension of connecting with myself for me. It gave me the courage to accept and have faith in the power of change. Gunjan Amrit leads the session with absolute sincerity and simplicity. It is easy to connect with the philosophy through her.',
		rating: 5,
		period: '4',
	},
	{
		imageSrc: '',
		name: 'Pragya',
		bio: "I started yoga with Gunjan in 2013. Jostling my way through some health woes at the time, my first kundalini class with Gunjan was so special and striking, that it got me hooked. Up until the present year, I have found myself going back to her sessions, which I truly believe she conducts with so much finesse, love, and all her heart. There's no way for learners in her sessions to possibly escape this energy that she so effortlessly infuses into each and every class.",
		rating: 5,
		period: '5',
	},
];

export const peopleStats = [
	{ percentage: '42', title: 'Decrease in stress' },
	{ percentage: '32', title: 'Less anxiety' },
	{ percentage: '50', title: 'Stronger nervous system' },
	{ percentage: '85', title: 'Reduction in risk of coronary disease' },
	{ percentage: '75', title: 'Relief from insomnia symptoms' },
];

export const qualifiedInstructors = [
	{
		experience: '5+',
		fName: 'Gunjan',
		lName: 'Amrit',
		experties: '- Kundalini Expert',
		imageUrl: instructor_one,
		videoUrl:
			"https://firebasestorage.googleapis.com/v0/b/seek-c3955.appspot.com/o/video%2Fplan-landing%2FGunjan's%20Intro%20-%20Made%20with%20Clipchamp.mp4?alt=media&token=8ad92394-9182-4762-a6f1-4781edf78b79",
	},
	{
		experience: '5+',
		fName: 'Mala',
		lName: 'Barua',
		experties: '- Inner Silence Meditation',
		imageUrl: instructor_two,
		videoUrl:
			"https://firebasestorage.googleapis.com/v0/b/seek-c3955.appspot.com/o/video%2Fplan-landing%2FMala's%20Intro%20-%20Made%20with%20Clipchamp%20(1).mp4?alt=media&token=43b567f4-a3ae-4a01-80bf-6d1f0a88c85b",
	},
	{
		experience: '5+',
		fName: 'Sukhmani Bajwa',
		lName: 'Kohli',
		experties: '- Kundalini Yoga Expert',
		imageUrl: instructor_three,
		videoUrl:
			"https://firebasestorage.googleapis.com/v0/b/seek-c3955.appspot.com/o/video%2Fplan-landing%2FSukhmani's%20Intro%20-%20Made%20with%20Clipchamp%20(1).mp4?alt=media&token=8b34d2a9-0f94-4662-ba7c-9d9b9482bdd7",
	},
];

export const customerTestimonials = [
	{
		name: 'Amit Chaturvedi',
		location: 'Telangana',
		imageUrl: '',
		videoUrl:
			'https://firebasestorage.googleapis.com/v0/b/seek-c3955.appspot.com/o/video%2Fplan-landing%2FAmit%20Chaturvedi%20-%20Made%20with%20Clipchamp.mp4?alt=media&token=714272b4-c548-4987-97c3-7a0b9e45d351',
	},
	{
		name: 'Neelakshi',
		location: 'Delhi',
		imageUrl: '',
		videoUrl:
			'https://firebasestorage.googleapis.com/v0/b/seek-c3955.appspot.com/o/video%2Fplan-landing%2FNeelakshi%20Barua%20(2%20years%20on%20Seek).mp4?alt=media&token=1aec2b23-c615-4f2e-b04c-ed3e1cd4f01e',
	},
	{
		name: 'Vardayni',
		location: 'Mumbai',
		imageUrl: '',
		videoUrl:
			'https://firebasestorage.googleapis.com/v0/b/seek-c3955.appspot.com/o/video%2Fplan-landing%2FVardayni%20-%20Testimonial.mp4?alt=media&token=99bdb95d-bb5f-4d23-8db7-ee77e638cfea',
	},
	{
		name: 'Anu Piplani',
		location: 'Mumbai',
		imageUrl: '',
		videoUrl:
			'https://firebasestorage.googleapis.com/v0/b/seek-c3955.appspot.com/o/video%2Fplan-landing%2FAnu%20Piplani%20(3%20years%20on%20Seek).mp4?alt=media&token=415c2880-aa80-4fd3-9fea-b828cbddc32b',
	},
	{
		name: 'Nirali Nanavati',
		location: 'Mumbai',
		imageUrl: '',
		videoUrl:
			'https://firebasestorage.googleapis.com/v0/b/seek-c3955.appspot.com/o/video%2Fplan-landing%2FNirali%20Nanavati%20(3%20years%20on%20Seek).mp4?alt=media&token=1e5a2595-aafc-42c7-bc9f-855b41dc7bdf',
	},
];

// export const customerLinkedinTestimonials = [
//     {
//         imageUrl: testimonial_url_one,
//     },
//     {
//
//         imageUrl: testimonial_url_two,
//     },{
//
//         imageUrl: testimonial_url_three,
//     }, {
//
//         imageUrl: testimonial_url_four,
//     },
// ]

export const managedAvailableClassSlots = [
	{ title: '5:00 AM', subtitle: 'Class at 5:30 AM', slotValue: '5 AM' },
	{ title: '6:00 AM', subtitle: 'Class at 6:30 AM', slotValue: '6 AM' },
	{ title: '7:00 AM', subtitle: 'Class at 7:30 AM', slotValue: '7 AM' },
	{ title: '8:00 AM', subtitle: 'Class at 8:30 AM', slotValue: '8 AM' },
	// {title: '9:00 AM', subtitle: '', slotValue: '9 AM'},
	{ title: '10:00 AM', subtitle: '', slotValue: '10 AM' },
	// {title: '3:00 PM', subtitle: '', slotValue: '3 PM'},
	// {title: '4:00 PM', subtitle: '', slotValue: '4 PM'},
	// {title: '5:00 PM', subtitle: '', slotValue: '5 PM'},
	{ title: '6:00 PM', subtitle: '', slotValue: '6 PM' },
	{ title: '7:00 PM', subtitle: 'Class at 7:30 PM', slotValue: '7 PM' },
	{ title: '8:00 PM', subtitle: 'Class at 8:30 PM', slotValue: '8 PM' },
	{ title: '9:00 PM', subtitle: 'Class at 9:30 PM', slotValue: '9 PM' },
	{ title: '10:00 PM', subtitle: '', slotValue: '10 PM' },
];

export const managedNotificationPreferences = [
	{
		title: 'WhatsApp Messages',
		subtitle: 'Get updates from us on WhatsApp',
		slotValue: '',
	},
];

export const getCurrentDate = () => {
	const currentDate = new Date().toLocaleDateString();
	const parts = currentDate.split('/');
	const formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
	// console.log("formattedDate",formattedDate);
	return formattedDate;
};

export const getRandomLightColor = (index: number) => {
	const colors = ['#F5EEFF'];
	return colors[0];
};

export const getRandomDarkColor = (index: number) => {
	// Array of available colors
	const colors = ['#B8ACF6'];

	// Return the randomly chosen color
	return colors[0];
};

export function sortSlots(slots: any) {
	if (!slots) return;
	return slots.sort((a: any, b: any) => {
		// Extract hours and AM/PM part from the strings
		const [hoursA, ampmA] = a.split(' ');
		const [hoursB, ampmB] = b.split(' ');

		// Convert hours to 24-hour format for sorting
		const hours24A =
			hoursA === '12' && ampmA === 'AM'
				? 0
				: ampmA === 'PM'
				? parseInt(hoursA) + 12
				: parseInt(hoursA);
		const hours24B =
			hoursB === '12' && ampmB === 'AM'
				? 0
				: ampmB === 'PM'
				? parseInt(hoursB) + 12
				: parseInt(hoursB);

		// Compare hours
		if (hours24A < hours24B) {
			return -1;
		} else if (hours24A > hours24B) {
			return 1;
		} else {
			// If hours are equal, compare AM/PM part
			return ampmA.localeCompare(ampmB);
		}
	});
}

export function upcomingCourse() {
	return [
		{
			name: 'Ancient Practices of Kundalini Yoga',
			author: 'by Ms. Gunjan Amrit',
			date: 'Starts 19 Jan 24',
		},
		{
			name: 'Ancient Practices of Kundalini Yoga',
			author: 'by Ms. Gunjan Amrit',
			date: 'Starts 19 Jan 24',
		},
		{
			name: 'Ancient Practices of Kundalini Yoga',
			author: 'by Ms. Gunjan Amrit',
			date: 'Starts 19 Jan 24',
		},
		{
			name: 'Ancient Practices of Kundalini Yoga',
			author: 'by Ms. Gunjan Amrit',
			date: 'Starts 19 Jan 24',
		},
	];
}

export const ClassModule = [
	{
		title: 'Module 1',
		name: 'Basic Spinal Series',
		description:
			"We'll systematically work with the energy in your spine, channeling it upwards to the chakras. This will bring clarity and focus to your meditation practice and everyday tasks.",
		duration: '1.5 Hr Live class at 5:45 AM | 7:45 AM',
		exercise: '4 Self-practices at your convenient time',
		highlights: [
			'Increase the circulation of the spinal fluid, which contributes to greater mental clarity and focus',
			'Strengthen and align your spine for improved overall health',
			'Boost your energy and vitality by experiencing deep relaxation and calm',
		],
	},
	{
		title: 'Module 2',
		name: 'Balancing hemispheres of the brain',
		description:
			"Our brain has two sides that need to work together for optimal function. When they're not in sync, it leads to frustration and ineffectiveness. In this insightful resource, we'll explore these parts of the brain, aiming to balance them and boost your understanding of how your brain works. Through active exercises, we'll sync up your brain activity for better outcomes.",
		duration: '1.5 Hr Live class at 5:45 AM | 7:45 AM',
		exercise: '4 Self-practices at your convenient time',
		highlights: [
			'Clarity in mind leading to a higher perspective in life',
			'Experience balance in your energy, thoughts, and emotions, while stress and fatigue fade away.',
		],
	},
	{
		title: 'Module 3',
		name: 'Balancing the Breath with Pranayama',
		description:
			'The mind follows the breath, which in turn guides the body. Breath control, a core principle of yoga, unlocks energy, healing, and transformation. Balanced breath leads to a balanced mind. This practice utilizes pranayama (breath control) to cultivate prana (life force), fostering stillness and a meditative state.',
		duration: '1.5 Hr Live class at 5:45 AM | 7:45 AM',
		exercise: '4 Self-practices at your convenient time',
		highlights: [
			'Ease anxiety, worry, stress, and become more present',
			'Decrease stagnation levels and mental distress in your body ',
			'Reduce your blood pressure, change your heart rate and improve your overall health by deepening your breath.',
		],
	},
	{
		title: 'Module 4',
		name: 'Applying the energetic locks/ Bandhas',
		description:
			'Explore ancient bandhas (energy locks) to channel prana (life force) for strength, clarity, and spiritual awakening. This valuable resource will help you unlock Kundalini energy through bandhas, promoting mind-body-spirit harmony in Kundalini Yoga.',
		duration: '1.5 Hr Live class at 5:45 AM | 7:45 AM',
		exercise: '4 Self-practices at your convenient time',
		highlights: [
			'Bandhas bring in balance, harmony and peace of mind.',
			'Bandhas clear out blocked energy passageways for free energy to flow in your body, chakras, and subtle bodies.',
			'The body locks heighten your awareness.',
		],
	},
	{
		title: 'Module 5',
		name: 'Power of Mantras and Meditation',
		description:
			"With this resource by your side you'll be able to harness mantras to awaken Kundalini energy. Sound vibrations transform your mind, chakras, and spirit. Cultivate inner peace and elevate your spiritual journey through chanting.",
		duration: '1.5 Hr Live class at 5:45 AM | 7:45 AM',
		exercise: '4 Self-practices at your convenient time',
		highlights: [
			'Learn how these sacred sounds resonate with the cosmic energy, elevating consciousness and invoking divine blessings.',
			"Chanting mantras calms the mind, promoting emotional balance and profound serenity amid life's challenges.",
			'Access deeper layers of your intuition and wisdom, guiding you towards clarity and understanding yourself',
		],
	},
	{
		title: 'Module 6',
		name: 'Foundation for infinity ',
		description:
			"Let us explore how building a foundation with physical movements, breathwork, bandhas, and mantras unlocks infinite radiance and energy within us. You'll find a holistic approach to nurturing physical, emotional, and spiritual well-being. This resource will help you establish a strong foundation, connecting you to the Earth and experiencing boundless energy. Feel the energy rise from lower to higher chakras, creating infinite space and energy in our mind body and soul.",
		duration: '1.5 Hr Live class at 5:45 AM | 7:45 AM',
		exercise: '4 Self-practices at your convenient time',
		highlights: [
			'Feel yourself expand beyond time and space into a realm of total peace and joy.',
			"Find stability from the inside in order to stay open and responsive instead of reactive to life's ebbs and flows",
			'Boost your mood, relax the mind and improve your mindfulness capabilities',
		],
	},
];

export const CourseHighlights = [
	'Kundalini Yoga needs physical effort.',
	'Beginners should take it slow and do what feels comfortable for them.',
	'Adapt gradually to ensure safety and sustainable progress.',
];

export const ExploreCommunityPoints = [
	'Elevate your daily routine with our exclusive "Daily Bites".',
	'Exciting lineup of monthly events and special sessions.',
	'Exchange stories, insights, and build meaningful connections with other Seekers.',
];

export function isEmpty(obj: any) {
	if (!obj) return true;
	return Object.keys(obj).length === 0;
}

export const KARMA_BASED_USER_TYPE = {
	user_with_kp_less_than_discount_percent: 'user_with_kp_less_than_10_percent',
	user_with_kp_greater_than_discount_percent:
		'user_with_kp_greater_than_10_percent',
	user_with_kp_less_than_min_required: 'user_with_kp_less_than_min_required',
};
const screenWidth = window.innerWidth;
const screenHeight = window.innerHeight;

export function pxToVw(px: number): number {
	return (100 * px) / screenWidth;
}

export function pxToVh(px: number): number {
	return (100 * px) / screenHeight;
}

// utils.ts
export const capitalizeFirstLetter = (str: string): string => {
	if (!str) return str;
	return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const capitalizeWords = (str: string): string => {
	if (!str) return str;
	return str.split(' ').map(capitalizeFirstLetter).join(' ');
};

export const insertEmptyObjects = (slots: any) => {
	return slots.reduce((acc: any, slot: any, index: number) => {
		acc.push(slot);
		if (index < slots.length - 1) {
			acc.push({});
		}
		return acc;
	}, []);
};

export const findIndexes = (arr: any, items: any) => {
	return items.map((item: any) =>
		arr.findIndex((option: any) =>
			Object.keys(item).every((key) => item[key] === option[key])
		)
	);
};

export const findObjectIndexes = (arr: any, targetObject: any) => {
	const index = arr.findIndex(
		(option: any) =>
			option.value === targetObject.value && option.title === targetObject.title
	);
	return index;
};

export const ProgressSteps = {
	SECTION_ONE: 16.65,
	SECTION_TWO: 8.325,
	SECTION_THREE: 33.3,
};

export const isMobileDevice = () => {
	return /Mobi|Android/i.test(navigator.userAgent);
};

export const generateTimeOptions = (selectedOption: number) => {
	const options = [];
	const startHour = 8;
	const endHour = 22; // 10 PM in 24-hour format
	const now = new Date();

	for (let hour = startHour; hour <= endHour; hour++) {
		for (let minutes = 0; minutes < 60; minutes += 15) {
			const time = new Date();
			time.setHours(hour);
			time.setMinutes(minutes);
			time.setSeconds(0);
			time.setMilliseconds(0);

			if (time > now && selectedOption === 1) {
				// Only add upcoming times
				const optionsStr = time.toLocaleTimeString('en-US', {
					hour: '2-digit',
					minute: '2-digit',
					hour12: true,
				});
				options.push(optionsStr);
			} else if (selectedOption === 2) {
				const optionsStr = time.toLocaleTimeString('en-US', {
					hour: '2-digit',
					minute: '2-digit',
					hour12: true,
				});
				options.push(optionsStr);
			}
		}
	}

	return options;
};

export const CounsellingTechniques = [
	'Reiki',
	'Meditation',
	'Hypnosis',
	'Kundalini',
	'Yoga',
	'Not Sure',
];

export const seekBackedInByImages = [
	'Images/poc-slide-one.webp',
	'Images/poc-slide-two.webp',
	'Images/poc-slide-three.webp',
	'Images/poc-slide-four.webp',
	'Images/poc-slide-one.webp',
	'Images/poc-slide-two.webp',
	'Images/poc-slide-three.webp',
	'Images/poc-slide-four.webp',
	'Images/poc-slide-one.webp',
	'Images/poc-slide-two.webp',
	'Images/poc-slide-three.webp',
	'Images/poc-slide-four.webp',
	'Images/poc-slide-one.webp',
	'Images/poc-slide-two.webp',
	'Images/poc-slide-three.webp',
	'Images/poc-slide-four.webp',
	'Images/poc-slide-one.webp',
	'Images/poc-slide-two.webp',
	'Images/poc-slide-three.webp',
	'Images/poc-slide-four.webp',
	'Images/poc-slide-one.webp',
	'Images/poc-slide-two.webp',
	'Images/poc-slide-three.webp',
	'Images/poc-slide-four.webp',
	'Images/poc-slide-one.webp',
	'Images/poc-slide-two.webp',
	'Images/poc-slide-three.webp',
	'Images/poc-slide-four.webp',
	'Images/poc-slide-one.webp',
	'Images/poc-slide-two.webp',
	'Images/poc-slide-three.webp',
	'Images/poc-slide-four.webp',
	'Images/poc-slide-one.webp',
	'Images/poc-slide-two.webp',
	'Images/poc-slide-three.webp',
	'Images/poc-slide-four.webp',
	'Images/poc-slide-one.webp',
	'Images/poc-slide-two.webp',
	'Images/poc-slide-three.webp',
	'Images/poc-slide-four.webp',
	'Images/poc-slide-one.webp',
	'Images/poc-slide-two.webp',
	'Images/poc-slide-three.webp',
	'Images/poc-slide-four.webp',
	'Images/poc-slide-one.webp',
	'Images/poc-slide-two.webp',
	'Images/poc-slide-three.webp',
	'Images/poc-slide-four.webp',
	'Images/poc-slide-one.webp',
	'Images/poc-slide-two.webp',
	'Images/poc-slide-three.webp',
	'Images/poc-slide-four.webp',
	'Images/poc-slide-one.webp',
	'Images/poc-slide-two.webp',
	'Images/poc-slide-three.webp',
	'Images/poc-slide-four.webp',
	'Images/poc-slide-one.webp',
	'Images/poc-slide-two.webp',
	'Images/poc-slide-three.webp',
	'Images/poc-slide-four.webp',
];

// export const IngressNudges = [
//     {
//         tag:'',
//         Icon: RenewIcon,
//         isVisible:false,
//         nudge_type:'Plan',
//         priority:1,
//         redirection_link:'',
//         title:'Renew your plan',
//         user_already_enrolled:false,
//     },
// ];

export const UTM_FOR_3_6_MONTHS = 'Working Professionals';

interface ScheduleItem {
	day: string;
	task_description: string;
	week: string;
}

export const groupByWeek = (schedule: ScheduleItem[]) => {
	return schedule?.reduce((acc: { [key: string]: ScheduleItem[] }, item) => {
		if (!acc[item.week.trim()]) {
			acc[item.week.trim()] = [];
		}
		acc[item.week.trim()].push(item);
		return acc;
	}, {});
};

const orderedKeys = [
	'list_item_one',
	'list_item_two',
	'list_item_three',
	'list_item_four',
	'list_item_five',
];

export const sortItemsByKey = (items: any) => {
	return orderedKeys
		.map((key) => items[key])
		.filter((item) => item !== undefined);
};

export const downloadAudio = async (audio: string, filename: string) => {
	const audioUrl = audio;
	const fileName = filename + '.mp3';

	const response = await fetch(audioUrl, {
		method: 'GET',
	});
	if (!response.ok) {
		throw new Error('Failed to fetch image');
	}
	const blob = await response.blob();

	const link = document.createElement('a');
	link.target = '_blank';
	link.href = URL.createObjectURL(blob);
	link.download = fileName;

	document.body.appendChild(link);
	link.click();

	document.body.removeChild(link);
	URL.revokeObjectURL(link.href);
};

// S5: capture the ad-link ?region hint (e.g. ?region=us) so it survives navigation from
// /challenge-onboarding to /plan/subscribe. Uses sessionStorage (NOT localStorage) so the hint is
// scoped to the current funnel session and does NOT leak into a later organic visit on the same
// browser (which would wrongly put an India user into USD). Returns the lowercased region or undefined.
export const resolveRegion = (): string | undefined => {
	try {
		const fromUrl = new URLSearchParams(window.location.search).get('region');
		if (fromUrl) {
			const val = fromUrl.trim().toLowerCase();
			sessionStorage.setItem('region', val);
			return val;
		}
		return sessionStorage.getItem('region') || undefined;
	} catch (e) {
		return undefined;
	}
};

export const isIOSDevice = (): boolean => {
	try {
		return /iPhone|iPad|iPod/i.test(navigator.userAgent);
	} catch (e) {
		return false;
	}
};

// Best-effort, same-page signal for "this browser probably isn't in India" — used ONLY to widen
// the intl-onboarding gate to catch a US-region iPhone arriving via a link with no ?region= tag.
// Must fail SAFE toward `false` (= "don't widen the gate") on any error or ambiguous reading,
// mirroring the existing India-safe-default philosophy already used server-side for pricing
// (`resolvePricingBucket` in the functions repo defaults to 'IN' on geo-lookup failure).
export const isLikelyNonIndiaLocale = (): boolean => {
	try {
		const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
		if (timeZone === 'Asia/Kolkata' || timeZone === 'Asia/Calcutta') {
			return false;
		}
		const lang = (navigator.language || '').toLowerCase();
		if (lang.endsWith('-in')) {
			return false;
		}
		return true;
	} catch (e) {
		return false;
	}
};

// Gate for showing the intl web-onboarding social-auth step. `intlSocialAuthEnabled` is the
// Remote Config kill switch (fetched by the caller) — pass it in, don't fetch it here (keeps this
// file free of a Firebase/remote-config dependency and keeps the function trivially testable).
export const shouldCollectEmail = (intlSocialAuthEnabled: boolean): boolean => {
	if (!intlSocialAuthEnabled) {
		return false;
	}
	const region = (resolveRegion() || '').trim().toLowerCase();
	// An explicit India hint always wins, even over a device signal that looks non-Indian (e.g. an
	// iPhone with US locale/timezone on an India-tagged link) — the most conservative reading of
	// "never break the India flow" when a deliberate region tag is present.
	if (region === 'in') {
		return false;
	}
	if (region) {
		return true;
	}
	return isIOSDevice() && isLikelyNonIndiaLocale();
};

export const generateUniqueId = (
	userId: string,
	courseId: string,
	batchId?: string
) => {
	const dataToHash = `${userId}-${courseId}-${batchId || ''}`;
	return CryptoJS.SHA256(dataToHash).toString(CryptoJS.enc.Hex);
};

export const isTouchDevice = function () {
	return 'ontouchstart' in window || 'onmsgesturechange' in window;
};
export const isDesktop =
	window.screenX !== 0 && !isTouchDevice() ? true : false;

export const TagColors: Record<string, string> = {
	Meditation_And_Movement: '#EBEFFF',
	Movement: '#FFF3E4',
	Meditation: '#F9F0FE',
};

export function convertTo12HourFormat(hours: number, mins: number) {
	// Determine AM or PM
	const period = hours >= 12 ? 'PM' : 'AM';

	// Convert hours to 12-hour format
	const twelveHour = hours % 12 || 12; // Converts '0' to '12' for midnight

	// Ensure minutes are always two digits
	const formattedMins = mins.toString().padStart(2, '0');

	// Construct the time string
	return `${twelveHour}:${formattedMins} ${period}`;
}

export function formatDateFromMilliseconds(milliseconds: number) {
	const date = new Date(milliseconds);

	// Use Intl.DateTimeFormat for formatting
	const day = date.getDate();
	const month = date.toLocaleString('en-US', { month: 'short' });
	const year = date.getFullYear().toString().slice(-2); // Get last 2 digits of the year

	return `${day} ${month}, ${year}`;
}

export const coursesTabs = [
	'Details',
	'Benefits',
	'About Course',
	'Testimonials',
	'Know your instructors',
	'FAQs',
];

export const eventsTabs = [
	'About',
	'What you get',
	'Why to join',
	'Ideal for',
	'Know your instructors',
	'FAQs',
];

export const planTestimonials = [
	{
		text: 'Sound healing meditation taught me to disconnect of work stress & be grateful of what all I have.',
		subtext: 'On using meditation to overcome work stress',
		name: 'Rajman Dubey',
		profession: 'IT Professional',
	},
	{
		text: "What I love about Seek is that there's always someone there to guide you, providing support every step of the way.",
		subtext: 'On finding true satisfaction',
		name: 'Soham Pandit',
		profession: 'Professor',
	},
	{
		text: 'The different practices really helped me feel better physically and grow spiritually—it’s been such a well-rounded experience.',
		subtext: 'On forming more consistent habits',
		name: 'Anu Sharma',
		profession: 'Housewife',
	},
	{
		text: "I was able to connect instantly within the first class, and the support has been incredible. It’s not just good; it's outstanding.",
		subtext: 'On finding peace from within',
		name: 'Rakshita Dev',
		profession: 'Dentist',
	},
	{
		text: 'As a single father of two, I struggled with intense anger. Meditation helped me find inner calmness.',
		subtext: 'On working through their feelings',
		name: 'Sunil Verma',
		profession: 'Businessman',
	},
	{
		text: 'After my knee injury, Kundalini yoga has accelerated my recovery and got me back to bodybuilding faster than I expected in a month.',
		subtext: 'On finding correct guidance',
		name: 'Sahil Garg',
		profession: 'Gym Trainer',
	},
	{
		text: 'After battling depression for five years, regular meditation helped me build willpower and find inner happiness.',
		subtext: 'On gaining confidence',
		name: 'Aarti Rao',
		profession: 'IAS aspirant',
	},
	{
		text: 'As a 2+ year meditation practitioner, Seek helped clarify my doubts and deepen my practice with instructor support.',
		subtext: 'On finding immense support',
		name: 'Pooja Thakur',
		profession: 'Lawyer',
	},
];

export const userProfileData = [
	{
		icon: userProfileIcon1,
		title: 'Working Professionals',
		description:
			'Learn powerful techniques to switch off from work stress, stop overthinking, and truly enjoy your personal time without feeling guilty.',
	},
	{
		icon: userProfileIcon2,
		title: 'Busy Parents',
		description:
			'Discover simple yet effective practices to help you create balance, prioritize self-care, and be fully present for your loved ones.',
	},
	{
		icon: userProfileIcon3,
		title: 'Chronic health sufferer',
		description:
			'Explore tailored practices designed to ease discomfort, support your healing process through scientifically-backed meditative practices.',
	},
	{
		icon: userProfileIcon4,
		title: 'Spiritual Seekers',
		description:
			'Engage in guided practices that help you cultivate mindfulness, reach inner peace, and unlock a deeper sense of connection to your true self.',
	},
	{
		icon: userProfileIcon5,
		title: 'Fitness Enthusiasts',
		description:
			'Learn techniques to speed up recovery, boost strength, and stay consistent on your fitness journey by combining meditation with your fitness routine.',
	},
];

export const getDeviceId = () => {
	const deviceIdKey = 'device_id';
	let deviceId = localStorage.getItem(deviceIdKey);
	if (!deviceId) {
		deviceId = uuidv4(); // Generate a new UUID
		localStorage.setItem(deviceIdKey, deviceId);
	}

	return deviceId;
};

export const getCurrencyBasedCurrencyType = (symbol: string): string => {
	switch (symbol) {
		case '$':
			return 'USD';
		case '₹':
			return 'INR';
		default:
			return 'INR';
	}
};

export const DAILY_CLASS_PAYMENT_TYPES = {
	SUBSCRIPTION: 'SUBSCRIPTION',
	ONE_TIME: 'ONE_TIME',
};

export const getRazorpayOptions = (
	description: string,
	price: number,
	name: string,
	contact: string,
	customerName: string,
	currency?: string,
	order_id?: string,
	paymentType?: string,
	handler?: (response: any) => Promise<void>,
	modal?: any,
	email?: string
) => {
	const options: any = {
		description,
		image:
			'https://firebasestorage.googleapis.com/v0/b/seek-c3955.appspot.com/o/seek-logo-icon-blue.png?alt=media&token=e73fb5ae-3f19-42d0-afe8-1b76a89cf66f',
		currency: getCurrencyBasedCurrencyType(currency || '₹'),
		key: process.env.REACT_APP_RAZORPAY_KEY,
		amount: price * 100,
		name,
		handler,
		theme: { color: '#4462EF' },
		payment_capture: 1,
		prefill: {
			email: email || 'contact@seekapp.co',
			contact,
			name: customerName,
		},
		modal,
	};

	if (paymentType === DAILY_CLASS_PAYMENT_TYPES.SUBSCRIPTION) {
		options.subscription_id = order_id;
	}

	return options;
};

export function loadRazorpayScript(src: any) {
	return new Promise((resolve) => {
		const script = document.createElement('script');
		script.src = src;
		script.onload = () => {
			resolve(true);
		};
		script.onerror = () => {
			resolve(false);
		};
		document.body.appendChild(script);
	});
}

export const mediaEndpoint = 'https://media.seekdaily.live/';
